export default "__VITE_ASSET__BiDtr4m2__"